import Portal from '../../Portal';
import Table from '../../Table/Table';

const OrderListModal = ({ isOpen, onClose, orders, month, year }) => {
  if (!isOpen) return null;

  return (
    <Portal>
      <div className="fixed inset-0 bg-black bg-opacity-50 z-[9999] flex items-center justify-center p-4">
        <div className="bg-white rounded-lg max-w-5xl w-full max-h-[90vh] overflow-hidden shadow-2xl">
          <div className="flex justify-between items-center p-6 border-b bg-gray-50">
            <h2 className="text-xl font-semibold text-gray-900">
              Orders - {month} {year} ({orders.length} orders)
            </h2>
            <button
              onClick={onClose}
              className="text-gray-400 hover:text-gray-600 p-1 rounded-full hover:bg-gray-200"
            >
              <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
              </svg>
            </button>
          </div>
          
          <div className="overflow-y-auto" style={{ maxHeight: 'calc(90vh - 80px)' }}>
            {orders.length > 0 ? (
              <div className="p-6">
                <div className="overflow-x-auto">
                  <Table header={["Order ID", "Customer", "Phone", "Order Date", "Action"]}>
                    {orders.map((order, index) => (
                      <tr
                        key={order.order_id || index}
                        className={index % 2 === 0 ? "bg-gray-50" : "bg-white"}
                      >
                        <td className="py-2 px-4 text-xs sm:text-sm text-gray-800 border-t">
                          {order.order_id}
                        </td>
                        <td className="py-2 px-4 text-xs sm:text-sm text-gray-800 border-t">
                          {order.full_name || 'N/A'}
                        </td>
                        <td className="py-2 px-4 text-xs sm:text-sm text-gray-800 border-t">
                          {order.phone || 'N/A'}
                        </td>
                        <td className="py-2 px-4 text-xs sm:text-sm text-gray-800 border-t">
                          {order.createdAt ? 
                            new Date(order.createdAt).toLocaleDateString("en-US", {
                              year: "numeric",
                              month: "short", 
                              day: "numeric",
                            }) : 'N/A'
                          }
                        </td>
                        <td className="py-2 px-4 text-xs sm:text-sm text-gray-800 border-t">
                          <a
                            className="text-white border border-primaryRed bg-primaryRed hover:bg-hoverRed font-medium rounded-lg text-sm px-3 py-1 text-center"
                            href={`/track-order?order_id=${order.order_id}`}
                          >
                            Track Now
                          </a>
                        </td>
                      </tr>
                    ))}
                  </Table>
                </div>
              </div>
            ) : (
              <div className="text-center py-12 text-gray-500">
                No orders found
              </div>
            )}
          </div>
        </div>
      </div>
    </Portal>
  );
};

export default OrderListModal;
